import React, { useCallback, useContext, useEffect } from "react";
import PublicPageShell from "components/PublicPageShell";
import { useHistory, useLocation } from "react-router-dom";
import { Spinner } from "@kui-react/spinner";
import agent from "server";
import { LOCALSTORAGE_ACTIVE_ORG_ID_KEY } from "constants/index";
import { safeLocalStorageSetItem } from "utils/localStorage";
import { clearPostLoginRedirect } from "utils/redirects";
import { useKas } from "contexts/KasContext";
import { UserContext } from "contexts/UserContext";
import { toast } from "utils/toast";

const AcceptInvite: React.FC = () => {
  const history = useHistory();
  const location = useLocation();
  const userContext = useContext(UserContext);
  const {
    isUserLoggedIn: kasIsAuthenticated,
    starfleetIdToken: kasStarfleetIdToken,
    user: kasUser,
  } = useKas();

  const inviteParam = new URLSearchParams(location.search).get("inviteId");

  // If no inviteId, redirect to default app route
  useEffect(() => {
    if (!inviteParam) {
      history.push("/");
    }
  }, [inviteParam, history]);

  const handleInvite = useCallback(
    async (inviteId: string) => {
      const res = await agent.Invites.accept(inviteId);
      if (!res.success || !res.data?.organizationId) {
        console.error(res.message);
        toast.error("Failed to join organization", {
          description:
            res.message || "Your invitation could not be accepted. Try again.",
        });
        clearPostLoginRedirect();
        history.push("/");
        return;
      }

      clearPostLoginRedirect();
      safeLocalStorageSetItem(
        LOCALSTORAGE_ACTIVE_ORG_ID_KEY,
        res.data.organizationId,
      );
      history.push(`/org/${res.data.organizationId}/environments`);
      window.location.reload();
    },
    [history],
  );

  useEffect(() => {
    if (
      inviteParam &&
      kasIsAuthenticated &&
      kasStarfleetIdToken &&
      kasUser &&
      !!userContext.me
    ) {
      handleInvite(inviteParam);
    }
  }, [
    handleInvite,
    inviteParam,
    kasIsAuthenticated,
    kasStarfleetIdToken,
    kasUser,
    userContext.me,
  ]);

  return (
    <PublicPageShell>
      <div className="min-h-screen flex items-center justify-center">
        <Spinner
          className="text-gray-700 dark:text-secondary"
          description="Accepting invitation..."
        />
      </div>
    </PublicPageShell>
  );
};

export default AcceptInvite;
